import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { CartContext } from '../../context/CartContext';
import LoginModal from '../shared/LoginModal';
import { menuAPI } from '../../utils/api';

// grouped categories with subcategories
const CATEGORY_GROUPS = [
  {
    id: 'main',
    title: 'Main Dishes',
    subs: [
      'Appetizer',
      'Breakfast Meals',
      'Chicken',
      'Pork',
      'Beef',
      'Sariwang Gulay',
      'Sinigang',
      'Lamang Dagat',
      'Bandehadong Almusal'
    ]
  },
  {
    id: 'pasta',
    title: 'Pasta & Pancit',
    subs: ['Casa Pasta', 'Espesyal Pancit & Lomi', 'Pancit | Pasta Tray']
  },
  {
    id: 'desserts',
    title: 'Desserts & Cakes',
    subs: ['Minatamis']
  },
  {
    id: 'drinks',
    title: 'Drinks',
    subs: ['Veggie Salads', 'Pitcher Juice', 'Coffee', 'Coffee & Ice Cream', 'Coffee-Free', 'Milkshake', 'Cocktails', 'Bottled Beers', 'Soda & Water', 'Fresh Fruit Shakes', 'Healthy Options', 'Mocktails', 'Wine']
  },
  {
    id: 'specials',
    title: 'Specials',
    subs: ['Kahanggang Salo-Salo', 'Kanin sa Pinggan', 'Party Trays']
  },
  {
    id: 'burgers',
    title: 'Burgers & Sandwiches',
    subs: ['Burger']
  }
];

// sample menu items - add/replace with real data later
const MENU_ITEMS = [
  // Appetizers
  { id: 1, img: '/images/menu/fries.jpg', title: 'French Fries', price: 'PHP 159.00', category: 'Appetizer' },
  { id: 2, img: '/images/menu/cheese-fries.jpg', title: 'Cheesy Fries', price: 'PHP 169.00', category: 'Appetizer' },
  { id: 3, img: '/images/menu/chicken-wings-and-fries.jpg', title: 'Chicken Wings and Fries', price: 'PHP 259.00', category: 'Appetizer' },
  { id: 4, img: '/images/menu/mozarella-sticks.jpg', title: 'Mozzarella Sticks', price: 'PHP 120.00', category: 'Appetizer' },
  { id: 5, img: '/images/menu/chicharon-bulak-lak.jpg', title: 'Chicharon Bulaklak', price: 'PHP 289.00', category: 'Appetizer' },
  { id: 6, img: '/images/menu/nachos.jpg', title: 'Nachos', price: 'PHP 220.00', category: 'Appetizer' },
  { id: 7, img: '/images/menu/lumpiang-shangai.jpg', title: 'Lumpiang Shanghai', price: 'PHP 259.00', category: 'Appetizer' },
  { id: 8, img: '/images/menu/calamari.jpg', title: 'Calamari', price: 'PHP 239.00', category: 'Appetizer' },
  { id: 9, img: '/images/menu/fish-fillet.jpg', title: 'Fish Fillet', price: 'PHP 349.00', category: 'Appetizer' },


  // Breakfast Meals (additional items provided)
  { id: 19, img: '/images/menu/pork-tapa.jpg', title: 'Pork Tapa', price: 'PHP 189.00', category: 'Breakfast Meals' },
  { id: 20, img: '/images/menu/pork-longganisa.jpg', title: 'Pork Longganisa', price: 'PHP 189.00', category: 'Breakfast Meals' },
  { id: 21, img: '/images/menu/hotdog.jpg', title: 'Hotdog', price: 'PHP 189.00', category: 'Breakfast Meals' },
  { id: 22, img: '/images/menu/daing-na-bangus.jpg', title: 'Daing na Bangus', price: 'PHP 189.00', category: 'Breakfast Meals' },
  { id: 23, img: '/images/menu/tocino-fingers.jpg', title: 'Tocino Fingers', price: 'PHP 189.00', category: 'Breakfast Meals' },
  { id: 24, img: '/images/menu/fish-fillet-rice-meal.jpg', title: 'Fish Fillet Rice Meal', price: 'PHP 189.00', category: 'Breakfast Meals' },
  { id: 25, img: '/images/menu/corned-beef.jpg', title: 'Corned Beef', price: 'PHP 189.00', category: 'Breakfast Meals' },
  { id: 26, img: '/images/menu/spam.jpg', title: 'Spam', price: 'PHP 189.00', category: 'Breakfast Meals' },
  { id: 27, img: '/images/menu/daing-na-bangus.jpg', title: 'Daing na Bangus Rice Meal', price: 'PHP 189.00', category: 'Breakfast Meals' },
  { id: 28, img: '/images/menu/pork-sisig-rice-meal.jpg', title: 'Pork Sisig Rice Meal', price: 'PHP 189.00', category: 'Breakfast Meals' },
  { id: 29, img: null, title: 'Chicken Wings with Rice', price: 'PHP 215.00', category: 'Breakfast Meals' }
  ,
  // Chicken items
  { id: 30, img: '/images/menu/chicken-alacasa.jpg', title: 'Chicken Ala Casa', price: 'PHP 419.00', category: 'Chicken' },
  { id: 31, img: '/images/menu/cordon-bleu.jpg', title: 'Cordon Bleu', price: 'PHP 349.00', category: 'Chicken' },
  { id: 32, img: '/images/menu/chicken-adobo.jpg', title: 'Chicken Adobo', price: 'PHP 329.00', category: 'Chicken' },
  { id: 33, img: '/images/menu/Grilled-Chicken.jpg', title: 'Grilled Chicken', price: 'PHP 289.00', category: 'Chicken' },
  { id: 34, img: '/images/menu/Fried-Chicken-Wings.jpg', title: 'Fried Chicken Wings', price: 'PHP 319.00', category: 'Chicken' },

  // Pork items
  { id: 35, img: '/images/menu/Lechon-Kawali.jpg', title: 'Lechon Kawali', price: 'PHP 279.00', category: 'Pork' },
  { id: 36, img: '/images/menu/inihaw-na-liempo.jpg', title: 'Inihaw na Liempo', price: 'PHP 329.00', category: 'Pork' },
  { id: 37, img: '/images/menu/crispy-kare-kare.jpg', title: 'Crispy Kare-Kare', price: 'PHP 369.00', category: 'Pork' },
  { id: 38, img: '/images/menu/pork-sisig.jpg', title: 'Pork Sisig', price: 'PHP 289.00', category: 'Pork' },
  { id: 39, img: '/images/menu/crispy-pata.jpg', title: 'Crispy Pata', price: 'PHP 668.00', category: 'Pork' },

  // Beef items
  { id: 40, img: '/images/menu/beef-mushroom.jpg', title: 'Beef Mushrooms', price: 'PHP 348.00', category: 'Beef' },
  { id: 41, img: '/images/menu/kinamatisan-beef-kaldereta.jpg', title: 'Kinamatisang Beef Caldereta', price: 'PHP 348.00', category: 'Beef' },
  { id: 42, img: '/images/menu/beef-salpicao.jpg', title: 'Beef Salpicao', price: 'PHP 329.00', category: 'Beef' },
  { id: 43, img: '/images/menu/beef-bulalo.jpg', title: 'Beef Bulalo', price: 'PHP 689.00', category: 'Beef' },

  // Sariwang Gulay
  { id: 44, img: '/images/menu/enselada-tortang-talong.jpg', title: 'Ensaladang Tortang Talong', price: 'PHP 189.00', category: 'Sariwang Gulay' },
  { id: 45, img: '/images/menu/kare-kareng-gulay.jpg', title: 'Kare-Kareng Gulay', price: 'PHP 189.00', category: 'Sariwang Gulay' },
  { id: 46, img: '/images/menu/pork-chopseuy.jpg', title: 'Pork Chop-Suey', price: 'PHP 280.00', category: 'Sariwang Gulay' },
  { id: 47, img: '/images/menu/crispy-pakbet.jpg', title: 'Crispy Pakbet', price: 'PHP 249.00', category: 'Sariwang Gulay' },

  // Sinigang
  { id: 48, img: '/images/menu/sinigang-salmon-meat.jpg', title: 'Sinigang Salmon Meat', price: 'PHP 419.00', category: 'Sinigang' },
  { id: 49, img: '/images/menu/sinigang-salmon-belly.jpg', title: 'Sinigang Salmon Belly', price: 'PHP 359.00', category: 'Sinigang' },
  { id: 50, img: '/images/menu/sinigang-tanigue.jpg', title: 'Sinigang na Tanigue', price: 'PHP 359.00', category: 'Sinigang' },
 // { id: 51, img: '/images/menu/sinigang-hipon.jpg', title: 'Sinigang na Hipon', price: 'PHP 379.00', category: 'Sinigang' },
  { id: 52, img: '/images/menu/sinigang-muslo.jpg', title: 'Sinigang na Muslo', price: 'PHP 359.00', category: 'Sinigang' },
  { id: 53, img: '/images/menu/sinigang-tuna-meat.jpg', title: 'Sinigang Tuna Meat', price: 'PHP 379.00', category: 'Sinigang' },
  { id: 54, img: '/images/menu/sinigang-baboy.jpg', title: 'Sinigang na Baboy', price: 'PHP 359.00', category: 'Sinigang' },
  { id: 55, img: '/images/menu/sinigang-baka.jpg', title: 'Sinigang na Baka', price: 'PHP 649.00', category: 'Sinigang' },

  // Lamang Dagat
  { id: 56, img: '/images/menu/shrimp-tempura.jpg', title: 'Shrimp Tempura', price: 'PHP 348.00', category: 'Lamang Dagat' },
  { id: 57, img: '/images/menu/baked-bangus.jpg', title: 'Baked Bangus', price: 'PHP 340.00', category: 'Lamang Dagat' },
  { id: 58, img: '/images/menu/baked-tahong.jpg', title: 'Baked Tahong', price: 'PHP 269.00', category: 'Lamang Dagat' },
  { id: 59, img: '/images/menu/adobong-pusit.jpg', title: 'Adobong Pusit', price: 'PHP 239.00', category: 'Lamang Dagat' },
  { id: 60, img: '/images/menu/buttered-shrimp.jpg', title: 'Buttered Shrimp', price: 'PHP 329.00', category: 'Lamang Dagat' },
  { id: 61, img: '/images/menu/chili-buttered-shrimp.jpg', title: 'Chili Garlic Shrimp', price: 'PHP 349.00', category: 'Lamang Dagat' },
  { id: 62, img: '/images/menu/seafood-chopsuey.jpg', title: 'Seafood Chop Suey', price: 'PHP 619.00', category: 'Lamang Dagat' },
  { id: 63, img: '/images/menu/cajun-mixed-seafoods.jpg', title: 'Cajun Mixed Seafoods', price: 'PHP 789.00', category: 'Lamang Dagat' },
  { id: 64, img: '/images/menu/buttered-mixed.jpg', title: 'Buttered Mixed Seafood', price: 'PHP 730.00', category: 'Lamang Dagat' },
  // Casa Pasta (added)
  { id: 65, img: '/images/menu/creamy-bacon-carbonara.jpg', title: 'Creamy Bacon Carbonara', price: 'PHP 469.00', category: 'Casa Pasta' },
  { id: 66, img: '/images/menu/casa-spaghetti.jpg', title: 'Casa Spaghetti', price: 'PHP 389.00', category: 'Casa Pasta' },
  { id: 67, img: '/images/menu/seafood-pasta.jpg', title: 'Seafood Pasta', price: 'PHP 350.00', category: 'Casa Pasta' },
  { id: 68, img: '/images/menu/beth-scampi.jpg', title: 'Beth Scampi', price: 'PHP 300.00', category: 'Casa Pasta' },
  { id: 69, img: '/images/menu/pasta-con-le-sarde.jpg', title: 'Pasta Con Le Sarde', price: 'PHP 260.00', category: 'Casa Pasta' },
  { id: 70, img: '/images/menu/chicken-alfredo.jpg', title: 'Chicken Alfredo', price: 'PHP 250.00', category: 'Casa Pasta' },
  { id: 71, img: '/images/menu/lasagna.jpg', title: 'Lasagna', price: 'PHP 270.00', category: 'Casa Pasta' },

  // Espesyal Pancit & Lomi (added)
  { id: 72, img: '/images/menu/pancit-bihon.jpg', title: 'Pancit Bihon', price: 'PHP 259.00', category: 'Espesyal Pancit & Lomi' },
  { id: 73, img: '/images/menu/pancit-canton.jpg', title: 'Pancit Canton', price: 'PHP 289.00', category: 'Espesyal Pancit & Lomi' },
  { id: 74, img: '/images/menu/pancit-sotanghon.jpg', title: 'Pancit Sotanghon', price: 'PHP 298.00', category: 'Espesyal Pancit & Lomi' },
  { id: 75, img: '/images/menu/pancit-canton-bihon.jpg', title: 'Pancit Canton-Bihon', price: 'PHP 279.00', category: 'Espesyal Pancit & Lomi' },
  { id: 76, img: '/images/menu/pancit-canton-sotanghon.jpg', title: 'Pancit Canton-Sotanghon', price: 'PHP 298.00', category: 'Espesyal Pancit & Lomi' },
  { id: 77, img: '/images/menu/pancit-miki-bihon.jpg', title: 'Pancit Miki-Bihon', price: 'PHP 249.00', category: 'Espesyal Pancit & Lomi' },
  { id: 78, img: '/images/menu/espesiyal-lomi.jpg', title: 'Espesyal Lomi', price: 'PHP 159.00', category: 'Espesyal Pancit & Lomi' },
  { id: 79, img: '/images/menu/overload-lomi.jpg', title: 'Overload Lomi', price: 'PHP 259.00', category: 'Espesyal Pancit & Lomi' },
  { id: 80, img: '/images/menu/batangas-chami.jpg', title: 'Batangas Chami', price: 'PHP 159.00', category: 'Espesyal Pancit & Lomi' }
  ,
  // Pancit | Pasta Tray
  { id: 81, img: '/images/menu/canton-medium.jpg', title: 'Canton Medium', price: 'PHP 650.00', category: 'Pancit | Pasta Tray' },
  { id: 82, img: '/images/menu/canton-large.jpg', title: 'Canton Large', price: 'PHP 850.00', category: 'Pancit | Pasta Tray' },
  { id: 83, img: '/images/menu/bihon-medium.jpg', title: 'Bihon Medium', price: 'PHP 500.00', category: 'Pancit | Pasta Tray' },
  { id: 84, img: '/images/menu/bihon-large.jpg', title: 'Bihon Large', price: 'PHP 750.00', category: 'Pancit | Pasta Tray' },
  { id: 85, img: '/images/menu/sotanghon-medium.jpg', title: 'Canton Sotanghon Medium', price: 'PHP 700.00', category: 'Pancit | Pasta Tray' },
  { id: 86, img: '/images/menu/sotanghon-large.jpg', title: 'Canton Sotanghon Large', price: 'PHP 900.00', category: 'Pancit | Pasta Tray' },
  { id: 87, img: '/images/menu/bihon-medium.jpg', title: 'Canton Bihon Medium', price: 'PHP 700.00', category: 'Pancit | Pasta Tray' },
  { id: 88, img: '/images/menu/bihon-large.jpg', title: 'Canton Bihon Large', price: 'PHP 900.00', category: 'Pancit | Pasta Tray' },
  { id: 89, img: '/images/menu/miki-bihon-medium.jpg', title: 'Miki Bihon Medium', price: 'PHP 650.00', category: 'Pancit | Pasta Tray' },
  { id: 90, img: '/images/menu/miki-bihon-large.jpg', title: 'Miki Bihon Large', price: 'PHP 850.00', category: 'Pancit | Pasta Tray' },
  { id: 91, img: '/images/menu/palabok-large.jpg', title: 'Palabok Large', price: 'PHP 1,050.00', category: 'Pancit | Pasta Tray' },
  { id: 92, img: '/images/menu/classic-carbonara-medium.jpg', title: 'Classic Carbonara Medium', price: 'PHP 900.00', category: 'Pancit | Pasta Tray' },
  { id: 93, img: '/images/menu/classic-carbonara-large.jpg', title: 'Classic Carbonara Large', price: 'PHP 1,100.00', category: 'Pancit | Pasta Tray' },
  { id: 94, img: '/images/menu/pinoy-style-spaghetti-medium.jpg', title: 'Pinoy Style Spaghetti Medium', price: 'PHP 900.00', category: 'Pancit | Pasta Tray' },
  { id: 95, img: '/images/menu/pinoy-style-spaghetti-large.jpg', title: 'Pinoy Style Spaghetti Large', price: 'PHP 1,100.00', category: 'Pancit | Pasta Tray' }
  ,
  // Minatamis
  { id: 96, img: '/images/menu/leche-flan.jpg', title: 'Leche Flan', price: 'PHP 140.00', category: 'Minatamis' },
  { id: 97, img: '/images/menu/buko-pandan.jpg', title: 'Buko Pandan', price: 'PHP 229.00', category: 'Minatamis' },
  { id: 98, img: '/images/menu/buko-salad.jpg', title: 'Buko Salad', price: 'PHP 229.00', category: 'Minatamis' },
  { id: 99, img: '/images/menu/halo-halo.jpg', title: 'Halo-halo', price: 'PHP 119.00', category: 'Minatamis' },

  // Veggie Salads
  { id: 101, img: '/images/menu/caesar-salad.jpg', title: 'Classic Caesar Salad', price: 'PHP 299.00', category: 'Veggie Salads' },
  { id: 102, img: '/images/menu/house-salad.jpg', title: 'House Salad', price: 'PHP 280.00', category: 'Veggie Salads' },
  { id: 103, img: '/images/menu/asian-salad.jpg', title: 'Asian Salad', price: 'PHP 255.00', category: 'Veggie Salads' },

  // Pitcher Juice
  { id: 104, img: null, title: 'Cucumber Juice (Pitcher)', price: 'PHP 160.00', category: 'Pitcher Juice' },
  { id: 105, img: null, title: 'Iced Tea (Pitcher)', price: 'PHP 160.00', category: 'Pitcher Juice' },
  { id: 106, img: null, title: 'Orange Juice (Pitcher)', price: 'PHP 160.00', category: 'Pitcher Juice' },
  { id: 107, img: null, title: 'Pineapple Juice (Pitcher)', price: 'PHP 160.00', category: 'Pitcher Juice' },

  // Iced Coffee 16 oz / Coffee items
  { id: 113, img: '/images/menu/americano.png', title: 'Americano (Iced 16oz)', price: 'PHP 100.00', category: 'Coffee' },
  { id: 114, img: '/images/menu/americano-orange.png', title: 'Americano and Orange (Iced)', price: 'PHP 120.00', category: 'Coffee' },
  { id: 115, img: '/images/menu/spanish-latte.png', title: 'Spanish Latte (Iced)', price: 'PHP 140.00', category: 'Coffee' },
  { id: 116, img: '/images/menu/casa-signature.png', title: 'Casa Signature (Iced)', price: 'PHP 150.00', category: 'Coffee' },
  { id: 117, img: '/images/menu/vanilla-latte.png', title: 'Vanilla Latte (Iced)', price: 'PHP 130.00', category: 'Coffee' },
  { id: 118, img: '/images/menu/iced-latte.png', title: 'Iced Latte', price: 'PHP 110.00', category: 'Coffee' },
  { id: 119, img: '/images/menu/caramel-latte.png', title: 'Caramel Latte (Iced)', price: 'PHP 130.00', category: 'Coffee' },
  { id: 120, img: '/images/menu/caramel-macchiato.png', title: 'Caramel Macchiato (Iced)', price: 'PHP 140.00', category: 'Coffee' },
  { id: 121, img: '/images/menu/white-choco-mocha.png', title: 'White Choco Mocha (Iced)', price: 'PHP 130.00', category: 'Coffee' },
  { id: 122, img: '/images/menu/iced-mocha.png', title: 'Iced Mocha', price: 'PHP 130.00', category: 'Coffee' },
  { id: 123, img: '/images/menu/matcha-espresso.png', title: 'Matcha and Espresso (Iced)', price: 'PHP 150.00', category: 'Coffee' },
  { id: 124, img: '/images/menu/hazelnut-latte.png', title: 'Hazelnut Latte (Iced)', price: 'PHP 130.00', category: 'Coffee' },
  // Hot Coffee 12 oz (also category Coffee)
  { id: 125, img: '/images/menu/espresso.png', title: 'Espresso', price: 'PHP 70.00', category: 'Coffee' },
  { id: 126, img: '/images/menu/espresso-americano.png',title: 'Espresso Americano', price: 'PHP 90.00', category: 'Coffee' },
  { id: 127, img: '/images/menu/cappuccino.png', title: 'Cappuccino', price: 'PHP 110.00', category: 'Coffee' },
  { id: 128, img: '/images/menu/latte.png', title: 'Latte', price: 'PHP 110.00', category: 'Coffee' },
  { id: 129, img: '/images/menu/affogato.png', title: 'Affogato', price: 'PHP 130.00', category: 'Coffee' },
  { id: 130, img: '/images/menu/vanilla-latte.png', title: 'Vanilla Latte (Hot)', price: 'PHP 130.00', category: 'Coffee' },
  { id: 132, img: '/images/menu/mocha.png', title: 'Mocha (Hot)', price: 'PHP 130.00', category: 'Coffee' },
  { id: 133, img: '/images/menu/white-choco-mocha.png', title: 'White Choco Mocha (Hot)', price: 'PHP 130.00', category: 'Coffee' },
  { id: 134, img: '/images/menu/spanish-latte.png', title: 'Spanish Latte (Hot)', price: 'PHP 130.00', category: 'Coffee' },
  { id: 135, img: '/images/menu/hot-caramel-latte.png', title: 'Hot Caramel Latte', price: 'PHP 130.00', category: 'Coffee' },
  { id: 136, img: '/images/menu/caramel-macchiato.png', title: 'Caramel Macchiato (Hot)', price: 'PHP 140.00', category: 'Coffee' },

  // Milk Shakes
  { id: 137, img: '/images/menu/vanilla-milkshake.png', title: 'Vanilla Milkshake', price: 'PHP 180.00', category: 'Milkshake' },
  { id: 138, img: '/images/menu/chocolate-milkshake.png', title: 'Chocolate Milkshake', price: 'PHP 180.00', category: 'Milkshake' },
  { id: 139, img: '/images/menu/ripe-mango-milkshake.png', title: 'Ripe Mango Milkshake', price: 'PHP 180.00', category: 'Milkshake' },
  { id: 140, img: '/images/menu/fresh-strawberry-ms.png', title: 'Fresh Strawberry Milkshake', price: 'PHP 180.00', category: 'Milkshake' },
  { id: 141, img: '/images/menu/fresh-banana-ms.png', title: 'Fresh Banana Milkshake', price: 'PHP 160.00', category: 'Milkshake' },
  { id: 142, img: '/images/menu/fresh-avocado-ms.png', title: 'Fresh Avocado Milkshake', price: 'PHP 180.00', category: 'Milkshake' },

  // Cocktails
  { id: 200, img: '/images/menu/classic-mojito.png', title: 'Classic Mojito', price: 'PHP 180.00', category: 'Cocktails' },
  { id: 201, img: '/images/menu/flavored-mojito.png', title: 'Flavored Mojito', price: 'PHP 199.00', category: 'Cocktails' },
  { id: 202, img: '/images/menu/singapore-sling.png', title: 'Singaporean Sling', price: 'PHP 180.00', category: 'Cocktails' },
  { id: 203, img: '/images/menu/frozen-strawberry.png', title: 'Frozen Strawberry', price: 'PHP 180.00', category: 'Cocktails' },
  { id: 204, img: '/images/menu/blue-hawaiian.png', title: 'Blue Hawaiian', price: 'PHP 180.00', category: 'Cocktails' },
  { id: 205, img: '/images/menu/daiquiri.png', title: 'Daiquiri', price: 'PHP 180.00', category: 'Cocktails' },
  { id: 206, img: '/images/menu/tequila-sunrise.png', title: 'Tequila Sunrise', price: 'PHP 180.00', category: 'Cocktails' },
  { id: 207, img: '/images/menu/mai-tai.png', title: 'Mai Tai', price: 'PHP 180.00', category: 'Cocktails' },
  { id: 208, img: '/images/menu/long-island.png', title: 'Long Island', price: 'PHP 180.00', category: 'Cocktails' },

  // Fresh Fruit Shakes
  { id: 210, img: '/images/menu/ripe-mango-milkshake.png', title: 'Ripe Mango Shake', price: 'PHP 120.00', category: 'Fresh Fruit Shakes' },
  { id: 211, img: '/images/menu/fresh-strawberry.png', title: 'Fresh Strawberry', price: 'PHP 130.00', category: 'Fresh Fruit Shakes' },
  { id: 212, img: '/images/menu/fresh-melon.png', title: 'Fresh Melon', price: 'PHP 110.00', category: 'Fresh Fruit Shakes' },
  { id: 213, img: '/images/menu/fresh-banana.png', title: 'Fresh Banana', price: 'PHP 110.00', category: 'Fresh Fruit Shakes' },
  { id: 214, img: '/images/menu/fresh-watermelon.png', title: 'Fresh Watermelon', price: 'PHP 120.00', category: 'Fresh Fruit Shakes' },
  { id: 215, img: '/images/menu/fresh-avocado.png', title: 'Fresh Avocado', price: 'PHP 140.00', category: 'Fresh Fruit Shakes' },
  { id: 216, img: '/images/menu/bartender_s-choice-2-fruits.png', title: "Bartender's Choice (2 Fruits)", price: 'PHP 160.00', category: 'Fresh Fruit Shakes' },
  { id: 217, img: '/images/menu/bartender_s-choice-3-fruits.png', title: "Bartender's Choice (3 Fruits)", price: 'PHP 180.00', category: 'Fresh Fruit Shakes' },

  // Healthy Options
  { id: 220, img: '/images/menu/fresh-lemonade.png', title: 'Fresh Lemonade', price: 'PHP 99.00', category: 'Healthy Options' },
  { id: 221, img: '/images/menu/pink-lemonade.png', title: 'Pink Lemonade', price: 'PHP 120.00', category: 'Healthy Options' },
  { id: 222, img: '/images/menu/green-apple-lemonade.png', title: 'Green Apple Lemonade', price: 'PHP 120.00', category: 'Healthy Options' },
  { id: 223, img: '/images/menu/fresh-lemonade-and-ginger.png', title: 'Fresh Lemon & Ginger', price: 'PHP 110.00', category: 'Healthy Options' },
  { id: 224, img: '/images/menu/fresh-lemonade-and-yakult.png', title: 'Fresh Lemon & Yakult', price: 'PHP 120.00', category: 'Healthy Options' },
  
  // Mocktails
  { id: 230, img: '/images/menu/fresh-lemon-mint-mocktail.png', title: 'Fresh Lemon & Mint', price: 'PHP 160.00', category: 'Mocktails' },
  { id: 231, img: '/images/menu/cucumber-lemon-mint-mocktail.png', title: 'Cucumber Lemon & Mint', price: 'PHP 180.00', category: 'Mocktails' },
  { id: 232, img: '/images/menu/pineapple-lemon-mint-mocktail.png', title: 'Pineapple Lemon & Mint', price: 'PHP 180.00', category: 'Mocktails' },
  { id: 233, img: '/images/menu/waterlemon-ginger-mint.png', title: 'Watermelon Ginger & Mint', price: 'PHP 180.00', category: 'Mocktails' },

  // Bottled Beers
  { id: 143, img: '/images/menu/smb-light.jpg', title: 'San Miguel Light (Bottle)', price: 'PHP 75.00', category: 'Bottled Beers' },
  { id: 144, img: '/images/menu/smb-apple.png', title: 'San Miguel Apple (Bottle)', price: 'PHP 75.00', category: 'Bottled Beers' },
  { id: 145, img: '/images/menu/smb-pale.jpg', title: 'Pale Pilsen (Bottle)', price: 'PHP 75.00', category: 'Bottled Beers' },
  { id: 146, img: '/images/menu/red-horse.webp', title: 'Red Horse 2 Liters', price: 'PHP 390.00', category: 'Bottled Beers' },
  { id: 147, img: '/images/menu/beer-bucket-assorted.png', title: 'Beer Bucket (Assorted)', price: 'PHP 429.00', category: 'Bottled Beers' },

  // Wine - Red
  { id: 240, img: '/images/menu/convento-wine.jpg', title: 'Convento House Wine (Red) - Portugal', price: 'PHP 700.00', category: 'Wine' },
  { id: 241, img: '/images/menu/castillo-cielo.png', title: 'Castillo Cielo - Spain', price: 'PHP 650.00', category: 'Wine' },
  { id: 242, img: '/images/menu/mano_s.png', title: 'Manos Cabernet Sauvignon - Chile', price: 'PHP 650.00', category: 'Wine' },
  { id: 243, img: '/images/menu/carlo-rossi-red.png', title: 'Carlo Rossi Sangria - USA', price: 'PHP 600.00', category: 'Wine' },
  
  // Wine - Pink
  { id: 244, img: '/images/menu/yellow-tail.png', title: 'Yellow Tail Pink Moscato - Australia', price: 'PHP 600.00', category: 'Wine' },
  { id: 245, img: '/images/menu/carlo-rossi-pink.jpg', title: 'Carlo Rossi Pink Moscato - USA', price: 'PHP 600.00', category: 'Wine' },
  
  // Wine - White
  { id: 246, img: '/images/menu/convento-white.png', title: 'Convento House Wine (White) - Portugal', price: 'PHP 700.00', category: 'Wine' },
  { id: 247, img: '/images/menu/carlo-rossi-white.jpg'  , title: 'Carlo Rossi White Moscato - USA', price: 'PHP 600.00', category: 'Wine' },
  
  // Wine - Non-Alcoholic
  { id: 248, img: '/images/menu/novellino.jpg', title: 'Novilleno Sparkling Red - Philippines', price: 'PHP 400.00', category: 'Wine' },
  { id: 249, img: '/images/menu/martini.png', title: 'Martini Sparkling White - Italy', price: 'PHP 650.00', category: 'Wine' },
  
  // Wine - By The Glass
  { id: 250, img: '/images/menu/house-wines.png', title: 'House Wines (By The Glass)', price: 'PHP 250.00', category: 'Wine' },

  // Soda and Water
  { id: 148, img: '/images/menu/bottled-water.png', title: 'Bottled Water 350 ML', price: 'PHP 30.00', category: 'Soda & Water' },
  { id: 149, img: '/images/menu/jack-coke.jpg', title: 'Jack Coke', price: 'PHP 120.00', category: 'Soda & Water' },

  // Kahanggang Salo-Salo
  { id: 150, img: '/images/menu/dapitan.jpg', title: 'Dapitan (Kahanggang Salo-Salo)', price: 'PHP 1,698.00', category: 'Kahanggang Salo-Salo' },
  { id: 151, img: '/images/menu/malolos.jpg', title: 'Malolos (Kahanggang Salo-Salo)', price: 'PHP 2,239.00', category: 'Kahanggang Salo-Salo' },
  { id: 152, img: '/images/menu/magdalo.jpg', title: 'Magdalo (Kahanggang Salo-Salo)', price: 'PHP 3,979.00', category: 'Kahanggang Salo-Salo' },
  { id: 153, img: '/images/menu/magdiwang.jpg', title: 'Magdiwang (Kahanggang Salo-Salo)', price: 'PHP 8,298.00', category: 'Kahanggang Salo-Salo' },

  // Kanin sa Pinggan
  { id: 154, img: '/images/menu/kaning-puti-platter.jpg', title: 'Kaning Puti Platter', price: 'PHP 160.00', category: 'Kanin sa Pinggan' },
  { id: 155, img: '/images/menu/kaning-puti-solo.jpg', title: 'Kaning Puti Solo', price: 'PHP 30.00', category: 'Kanin sa Pinggan' },
  { id: 156, img: '/images/menu/sinangag-platter.jpg', title: 'Classic Sinangag Platter', price: 'PHP 180.00', category: 'Kanin sa Pinggan' },
  { id: 157, img: '/images/menu/sinangag-solo.jpg', title: 'Classic Sinangag Solo', price: 'PHP 35.00', category: 'Kanin sa Pinggan' },
  { id: 158, img: '/images/menu/java-rice-platter.jpg', title: 'Java Rice', price: 'PHP 200.00', category: 'Kanin sa Pinggan' },
  { id: 159, img: '/images/menu/young-chow-fried-rice.jpg', title: 'Young Chow Fried Rice', price: 'PHP 220.00', category: 'Kanin sa Pinggan' },
  { id: 160, img: '/images/menu/salted-rice-platter.jpg', title: 'Salted Rice', price: 'PHP 200.00', category: 'Kanin sa Pinggan' },
  { id: 161, img: null, title: 'Seafood Rice', price: 'PHP 280.00', category: 'Kanin sa Pinggan' },

  // Party Trays
  { id: 162, img: '/images/menu/fish-fillet-platter.jpg', title: 'Fish Fillet Tray', price: 'PHP 1,029.00', category: 'Party Trays' },
  { id: 163, img: '/images/menu/calamari-platter.jpg', title: 'Calamari Tray', price: 'PHP 1,029.00', category: 'Party Trays' },
  { id: 164, img: '/images/menu/crispy-kare-kare-platter.jpg', title: 'Crispy Kare-Kare Tray', price: 'PHP 1,149.00', category: 'Party Trays' },
  { id: 165, img: '/images/menu/sisig-platter.jpg', title: 'Pork Sisig Tray', price: 'PHP 1,449.00', category: 'Party Trays' },
  { id: 166, img: '/images/menu/lumpiang-shangai-platter.jpg', title: 'Lumpiang Shanghai Tray', price: 'PHP 1,319.00', category: 'Party Trays' },
  { id: 167, img: '/images/menu/beef-mushroom-platter.jpg', title: 'Beef Mushrooms Platter', price: 'PHP 2,189.00', category: 'Party Trays' },
  { id: 168, img: '/images/menu/kinamatisan-beef-kaldereta-platter.jpg', title: 'Kinamatisang Beef Caldereta Platter', price: 'PHP 2,189.00', category: 'Party Trays' },
  { id: 169, img: '/images/menu/cordon-bleu-platter.jpg', title: 'Chicken Cordon Bleu Platter', price: 'PHP 1,789.00', category: 'Party Trays' },
  { id: 170, img: '/images/menu/chicken-wings-platter.jpg', title: 'Chicken Wings Platter', price: 'PHP 1,599.00', category: 'Party Trays' },
  { id: 171, img: '/images/menu/crispy-pakbet-platter.jpg', title: 'Crispy Pakbet Platter', price: 'PHP 1,129.00', category: 'Party Trays' },
  { id: 172, img: '/images/menu/seafood-chopsuey-platter.jpg', title: 'Seafood Chop Suey Platter', price: 'PHP 1,489.00', category: 'Party Trays' }
];


const MenuSection = () => {
  const [activeCat, setActiveCat] = useState('All');
  const [expandedGroup, setExpandedGroup] = useState(null);
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);

  // search state
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const searchInputRef = useRef(null);

  // Fetch menu items from API
  useEffect(() => {
    const fetchMenuItems = async () => {
      try {
        setLoading(true);
        const response = await menuAPI.getAll({ per_page: 10000 });
        
        // Handle paginated response: response.data.data.data or response.data.data
        let apiItems = [];
        if (response.data && response.data.data) {
          if (response.data.data.data) {
            // Paginated response: { success: true, data: { data: [...], per_page, etc } }
            apiItems = response.data.data.data;
          } else if (Array.isArray(response.data.data)) {
            // Array response: { success: true, data: [...] }
            apiItems = response.data.data;
          }
        } else if (Array.isArray(response.data)) {
          // Direct array: response.data = [...]
          apiItems = response.data;
        }
        
        console.log('Raw API response:', response.data); // Debug
        console.log('Extracted API items:', apiItems); // Debug
        
        if (apiItems && apiItems.length > 0) {
          // Convert API items to menu item format, then combine with hardcoded items
          const apiMenuItems = apiItems.map((item, idx) => {
            let category = item.category || 'Drinks';
            
            // Map generic "Drinks" category to specific subcategories based on item name
            if (category.toLowerCase() === 'drinks') {
              const name = (item.name || '').toLowerCase();
              if (name.includes('coke') || name.includes('sprite') || name.includes('royal') || name.includes('water')) {
                category = 'Soda & Water';
              } else if (name.includes('coffee') || name.includes('americano') || name.includes('latte') || name.includes('cappuccino')) {
                category = 'Coffee';
              } else if (name.includes('beer')) {
                category = 'Bottled Beers';
              } else if (name.includes('juice')) {
                category = 'Pitcher Juice';
              }
            }
            
            return {
              id: item.menu_item_id || item.id || (1000 + idx),
              menu_item_id: item.menu_item_id || item.id || (1000 + idx), // Store database ID for API calls
              title: item.name || item.title || '',
              price: item.price ? `PHP ${parseFloat(item.price).toFixed(2)}` : item.price,
              category: category,
              img: item.image_url || null,
              status: item.status || 'available',
              is_available: item.is_available === 1 ? true : item.is_available === 0 ? false : (item.status !== 'unavailable' && item.status !== 'sold_out'),
              description: item.description || ''
            };
          });
          
          console.log('Converted API items:', apiMenuItems); // Debug
          
          // Create a map of API items by name for quick lookup
          const apiItemMap = {};
          apiMenuItems.forEach(item => {
            if (item.title) {
              apiItemMap[item.title.toLowerCase()] = item;
            }
          });
          
          // Start with hardcoded items, but replace Drinks category items with API items
          const mergedItems = MENU_ITEMS.map(hardcodedItem => {
            const apiItem = apiItemMap[hardcodedItem.title.toLowerCase()];
            if (apiItem) {
              // Found in API, use API data
              return apiItem;
            }
            return hardcodedItem;
          });
          
          // Add any API items that don't exist in hardcoded list (for new items)
          apiMenuItems.forEach(apiItem => {
            const exists = mergedItems.some(item => 
              item.title.toLowerCase() === apiItem.title.toLowerCase()
            );
            if (!exists) {
              mergedItems.push(apiItem);
            }
          });
          
          console.log('Merged items:', mergedItems); // Debug
          setMenuItems(mergedItems);
        } else {
          // No API items, use hardcoded
          console.warn('No items from API, using hardcoded menu items');
          setMenuItems(MENU_ITEMS);
        }
      } catch (error) {
        console.error('Failed to fetch menu items:', error);
        console.warn('Using fallback hardcoded menu items');
        setMenuItems(MENU_ITEMS); // Fallback to hardcoded items on error
      } finally {
        setLoading(false);
      }
    };

    fetchMenuItems();
  }, []);

  const visibleItems = menuItems.filter((it) => {
    const matchesCategory = activeCat === 'All' || it.category === activeCat;
    if (!searchQuery.trim()) return matchesCategory;
    const q = searchQuery.toLowerCase();
    const matchesSearch = (it.title && it.title.toLowerCase().includes(q)) || (it.category && it.category.toLowerCase().includes(q));
    return matchesCategory && matchesSearch;
  });

  // Deduplicate visible items by title+price to avoid rendering repeated cards when the data contains duplicates
  const uniqueVisible = [...new Map(
    visibleItems.map((it) => [((it.title || '').toLowerCase().trim() + '|' + (it.price || '')), it])
  ).values()];

  // modal state
  const [selectedItem, setSelectedItem] = useState(null);
  const [qty, setQty] = useState(1);
  const isModalOpen = Boolean(selectedItem);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') setSelectedItem(null);
    };
    if (isModalOpen) document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isModalOpen]);

  // focus search input when opened
  useEffect(() => {
    if (searchOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [searchOpen]);

  const navigate = useNavigate();
  const { isLoggedIn, openLoginModal } = useContext(AuthContext);
  const { addItem } = useContext(CartContext);

  const openModal = (item) => {
    // When user clicks an item we still open the item details modal (existing behavior)
    setSelectedItem(item);
    setQty(1);
  };

  const closeModal = () => setSelectedItem(null);

  const changeQty = (delta) => setQty((q) => Math.max(1, q + delta));

  const addToTray = () => {
    // Guest-friendly: allow adding to cart even when not logged-in. Persisted in localStorage by CartContext.
    if (!selectedItem) return;
    
    // Check if item is available (is_available can be 0, false, or status can be unavailable/sold_out)
    if (selectedItem.status === 'unavailable' || selectedItem.status === 'sold_out' || selectedItem.is_available === false) {
      alert('This item is currently unavailable.');
      return;
    }
    
    try {
      // Parse price string (e.g., "PHP 159.00") to numeric value
      const priceMatch = selectedItem.price?.match(/[\d,]+\.?\d*/);
      const numericPrice = priceMatch ? parseFloat(priceMatch[0].replace(/,/g, '')) : 0;
      
      // Create item with numeric price for cart
      const cartItem = {
        ...selectedItem,
        price: numericPrice
      };
      
      addItem(cartItem, qty);
    } catch (e) {
      console.warn('Failed to add item to cart', e);
    }
    // Close modal but stay on the menu page (do NOT navigate to /cart)
    setSelectedItem(null);
  };

  const toggleGroup = (groupId) => {
    setExpandedGroup((g) => (g === groupId ? null : groupId));
    // when changing group, reset activeCat to All so subcategory click controls filtering
    setActiveCat('All');
  };

  return (
  <section id="menu" className="bg-white text-black py-12 sm:py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
  <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bebas text-center mb-6 text-black">MENU</h2>

        {/* groups row */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4 mb-4">
          <div className="flex flex-wrap items-center gap-2 sm:gap-4 flex-1">
              <button
                onClick={() => { setActiveCat('All'); setExpandedGroup(null); }}
                className={`py-2 px-3 sm:px-4 rounded-full text-xs sm:text-sm whitespace-nowrap ${
                activeCat === 'All' ? 'bg-black text-white' : 'bg-gray-100 text-gray-700'
              }`}
            >
              All
            </button>

            {CATEGORY_GROUPS.map((g) => (
              <button
                key={g.id}
                onClick={() => toggleGroup(g.id)}
                className={`py-2 px-3 sm:px-4 rounded-full text-xs sm:text-sm whitespace-nowrap ${
                    expandedGroup === g.id ? 'bg-black text-white' : 'bg-gray-100 text-gray-700'
                  }`}
              >
                {g.title}
              </button>
            ))}
          </div>

          <div className="flex-shrink-0 flex items-center gap-2 self-end sm:self-auto">
            {searchOpen ? (
              <div className="flex items-center bg-white rounded-full px-3 py-2 border border-gray-300 shadow-sm">
                <input
                  ref={searchInputRef}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={(e) => { if (e.key === 'Escape') { setSearchOpen(false); setSearchQuery(''); } }}
                  className="bg-transparent outline-none text-xs sm:text-sm text-gray-900 placeholder:text-gray-400 px-2 w-32 sm:w-40 md:w-64"
                  placeholder="Search menu"
                />
                {searchQuery && (
                  <button
                    onClick={() => setSearchQuery('')}
                    className="text-gray-600 hover:text-gray-800 px-2"
                    aria-label="clear search"
                  >
                    ✕
                  </button>
                )}
                <button
                  onClick={() => { setSearchOpen(false); setSearchQuery(''); }}
                  className="ml-1 w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center text-gray-700 hover:bg-gray-100"
                  aria-label="close search"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            ) : (
              <button
                aria-label="search menu"
                onClick={() => setSearchOpen(true)}
                className="w-10 h-10 rounded-full border border-gray-300 flex items-center justify-center text-gray-700 hover:bg-gray-100 shadow-sm"
              >
                <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z" />
                </svg>
              </button>
            )}
          </div>
        </div>

        {/* subcategories row (shows when a group is expanded) */}
        {expandedGroup && (
          <div className="mb-6 sm:mb-8">
            <div className="flex flex-wrap items-center gap-2 sm:gap-3">
              {CATEGORY_GROUPS.find((g) => g.id === expandedGroup).subs.map((sub) => (
                <button
                  key={sub}
                  onClick={() => setActiveCat(sub)}
                  className={`py-2.5 sm:py-2 px-4 sm:px-3 md:px-4 rounded-full text-xs sm:text-sm whitespace-nowrap transition-colors ${
                      activeCat === sub ? 'bg-black text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                >
                  {sub}
                </button>
              ))}
            </div>
          </div>
        )}

        {loading ? (
          <div className="flex justify-center items-center py-20">
            <div className="text-gray-500">Loading menu...</div>
          </div>
        ) : (
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4 md:gap-6 lg:gap-8">
          {uniqueVisible.map((item) => {
            const isUnavailable = item.status === 'unavailable' || item.status === 'sold_out' || item.is_available === false;
            return (
            <div
              key={item.id}
              role="button"
              tabIndex={0}
              onClick={() => openModal(item)}
              onKeyPress={(e) => { if (e.key === 'Enter') openModal(item); }}
              className={`bg-white rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 flex flex-col items-center shadow-sm min-h-[18rem] sm:min-h-[20rem] border border-gray-200 cursor-pointer hover:shadow-lg focus:outline-none transition-shadow active:scale-[0.98] ${isUnavailable ? 'opacity-60' : ''}`}
            >
              <div className="w-28 h-28 sm:w-32 sm:h-32 mb-4 sm:mb-5 rounded-md overflow-hidden flex items-center justify-center bg-gray-50">
                {item.img ? (
                  <img src={item.img} alt={item.title} className="w-full h-full object-cover" />
                ) : (
                  <svg className="w-16 h-16 text-gray-400" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="32" cy="32" r="30" fill="transparent" stroke="white" strokeOpacity="0.12" />
                    <path d="M20 38c2-6 10-7 14-4 4-3 12-2 14 4" stroke="white" strokeOpacity="0.85" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M24 30c1-3 5-5 8-3 3-2 7-1 8 3" stroke="white" strokeOpacity="0.6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                )}
              </div>
              <h3 className="text-sm sm:text-base font-montserrat font-bold mb-2 text-gray-900 text-center line-clamp-2">{item.title}</h3>
              <div className="w-1/2 border-t border-gray-200 my-2"></div>
              <p className="mb-3 sm:mb-4 text-xs sm:text-sm text-gray-600">{item.price}</p>
              {isUnavailable ? (
                <span className="mt-auto bg-gray-300 text-gray-600 px-5 sm:px-6 py-2 sm:py-2.5 rounded-full text-xs sm:text-sm cursor-not-allowed">
                  {item.status === 'sold_out' ? 'Sold Out' : 'Unavailable'}
                </span>
              ) : (
                <button
                  onClick={(e) => { e.stopPropagation(); openModal(item); }}
                  className="mt-auto bg-black hover:bg-gray-800 text-white px-5 sm:px-6 py-2 sm:py-2.5 rounded-full text-xs sm:text-sm transition-colors active:scale-95"
                  aria-label={`Order ${item.title}`}
                >
                  Order
                </button>
              )}
            </div>
            );
          })}
        </div>
        )}
        {/* Login modal is rendered here so it can open via context */}
        <LoginModal />
      </div>

      {/* Modal */}
      {isModalOpen && selectedItem && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-2">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={closeModal}
            aria-hidden
          />

    <div className="relative bg-white rounded-lg sm:rounded-xl md:rounded-2xl max-w-[70vw] sm:max-w-md md:max-w-2xl lg:max-w-3xl w-full max-h-[65vh] sm:max-h-[85vh] md:max-h-[90vh] overflow-y-auto p-2 sm:p-4 md:p-6 lg:p-8 text-black shadow-2xl border border-gray-200">
                <button
                  onClick={closeModal}
                  className="absolute top-1 right-1 sm:top-2 sm:right-2 md:top-3 md:right-3 w-5 h-5 sm:w-7 sm:h-7 md:w-8 md:h-8 flex items-center justify-center text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-full transition-colors z-10 text-[10px] sm:text-base"
                  aria-label="Close"
                >
                  ✕
                </button>

            <div className="flex flex-col md:flex-row items-stretch gap-2 sm:gap-3 md:gap-5 lg:gap-6">
              {/* hero-left layout: image on the left (larger) on md+, stacked on small screens */}
              <div className="md:w-1/3 w-full h-24 sm:h-40 md:h-auto rounded overflow-hidden bg-gray-100 flex-shrink-0">
                {selectedItem.img ? (
                  <img src={selectedItem.img} alt={selectedItem.title} className="w-full h-full object-cover object-center block" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <svg className="w-7 h-7 sm:w-12 sm:h-12 text-gray-300" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="32" cy="32" r="30" stroke="#e5e7eb" strokeWidth="2" />
                    </svg>
                  </div>
                )}
              </div>

              <div className="flex-1 flex flex-col justify-start min-w-0">
                <h3 className="text-[13px] sm:text-lg md:text-xl lg:text-2xl font-montserrat mb-1 sm:mb-2 pr-5 font-semibold leading-tight">{selectedItem.title}</h3>
                <p className="text-[9px] sm:text-xs md:text-sm text-gray-600 mb-1 sm:mb-2 md:mb-3 line-clamp-2">{selectedItem.description || 'Delicious dish from Casa Gatchalian. Add it to your tray and enjoy!'}</p>
                <p className="text-[11px] sm:text-base md:text-lg font-semibold mb-2 sm:mb-3 text-gray-900">{selectedItem.price}</p>

                <div className="flex items-center gap-1 sm:gap-3 mb-2 sm:mb-4">
                  <div className="flex items-center gap-1 sm:gap-2">
                    <button
                      onClick={() => changeQty(-1)}
                      aria-label="Decrease quantity"
                      disabled={qty <= 1}
                      className={`w-6 h-6 sm:w-9 sm:h-9 md:w-9 md:h-9 flex items-center justify-center rounded-full border border-gray-300 text-gray-700 transition-colors text-xs sm:text-base ${qty <= 1 ? 'opacity-40 cursor-not-allowed' : 'hover:bg-gray-100 active:scale-95'}`}
                    >
                      −
                    </button>

                    <input
                      type="number"
                      min={1}
                      step={1}
                      value={qty}
                      onChange={(e) => {
                        const v = parseInt(e.target.value, 10);
                        if (Number.isNaN(v)) {
                          setQty(1);
                        } else {
                          setQty(Math.max(1, v));
                        }
                      }}
                      onBlur={() => setQty((q) => Math.max(1, q))}
                      aria-label="Quantity"
                      className="no-spinner w-9 sm:w-14 md:w-16 text-center font-medium text-[11px] sm:text-base text-gray-800 border border-gray-300 rounded px-1 sm:px-2 py-0.5 sm:py-1"
                    />

                    <button
                      onClick={() => changeQty(1)}
                      aria-label="Increase quantity"
                      className="w-6 h-6 sm:w-9 sm:h-9 md:w-9 md:h-9 flex items-center justify-center rounded-full border border-gray-300 text-gray-700 hover:bg-gray-100 transition-colors active:scale-95 text-xs sm:text-base"
                    >
                      +
                    </button>
                  </div>
                </div>

                <div className="flex items-center gap-2 sm:gap-3">
                  {(selectedItem.status === 'unavailable' || selectedItem.status === 'sold_out' || selectedItem.is_available === false) ? (
                    <div className="bg-gray-200 text-gray-600 px-3 sm:px-6 md:px-8 py-1 sm:py-2.5 rounded-full text-[10px] sm:text-sm md:text-base w-full sm:w-auto font-medium text-center">
                      {selectedItem.status === 'sold_out' ? 'Sold Out' : 'Unavailable'}
                    </div>
                  ) : (
                    <button
                      onClick={addToTray}
                      className="bg-black hover:bg-gray-800 text-white px-3 sm:px-6 md:px-8 py-1 sm:py-2.5 rounded-full text-[10px] sm:text-sm md:text-base transition-colors active:scale-95 w-full sm:w-auto font-medium"
                    >
                      Add to My Tray
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default MenuSection;
